import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('dashNotFourthChar', /^.{4,8}-/);
